type ScoresViewOptions = {
    showIngredientSuppliers: boolean;
    visibleSuppliersCount: number;
    isIngredientOwner: boolean;
};

export type IngredientScoresView = "none" | "one" | "multiple";

export const selectIngredientScoresView = (options: ScoresViewOptions): IngredientScoresView => {
    const { showIngredientSuppliers, visibleSuppliersCount, isIngredientOwner } = options;

    if (!showIngredientSuppliers) {
        return "one";
    }

    if (visibleSuppliersCount === 0) {
        return isIngredientOwner ? "none" : "one";
    }

    return visibleSuppliersCount === 1 ? "one" : "multiple";
};
